import { Embroidery } from 'src/types'
import {
  notThumbEmbroidery,
  liningEmbroidery,
  thumbEmbroidery
  // circleHollowOutEmbroidery
} from 'src/features/gorilla/drawer/common/back/embroidery'

const liningEmbroideryObject = {
  first: {
    x: 110,
    y: -75,
    position: 'leatherLiningFirst'
  },
  second: {
    x: 115,
    y: -30,
    position: 'leatherLiningSecond'
  }
}

export const liningEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  embroideries: Embroidery[],
  step: 'first' | 'second',
  fontSize?: string
): void => {
  const isEmbroideryOfLining = embroideries?.some((x) => x.position.value === liningEmbroideryObject[step].position)
  if (isEmbroideryOfLining) {
    liningEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === liningEmbroideryObject[step].position),
      liningEmbroideryObject[step].x,
      liningEmbroideryObject[step].y,
      fontSize
    )
  }
}

export const thumbEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryDraw)
    thumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -115,
      30,
      -15
    )
}

const nonThumbEmbroideryObject = {
  middleFinger: {
    x: -140,
    y: -190,
    numerator: 5
  },
  ringFinger: {
    x: -60,
    y: -80,
    numerator: -5
  },
  childFinger: {
    x: -70,
    y: -45,
    numerator: -2
  }
}

export const nonThumbEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  fingerType: 'middleFinger' | 'ringFinger' | 'childFinger',
  embroideries: Embroidery[]
): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === fingerType)
  if (isEmbroideryDraw) {
    notThumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === fingerType),
      nonThumbEmbroideryObject[fingerType].x,
      nonThumbEmbroideryObject[fingerType].y,
      nonThumbEmbroideryObject[fingerType].numerator
    )
  }
}

// export const circleHollowOutEmbroideryDrawer = (
//   ctx: CanvasRenderingContext2D,
//   embroideries: Embroidery[]
// ) => {
//   const filterFunction = (x: Embroidery) => x.position.value === 'circleHollowOut'
//   const isEmbroideryOfCircleHollowOut = embroideries.some(filterFunction)
//   if (isEmbroideryOfCircleHollowOut) {
//     circleHollowOutEmbroidery(ctx, embroideries.find(filterFunction), 0, 0)
//   }
// }
